import { ReactNode, FunctionComponent, createElement, isValidElement } from 'react';

export const universalRenderer = (node: ReactNode | (() => ReactNode) | FunctionComponent<any>) => {
	// If it's already a valid React element, return it as-is
	if (isValidElement(node)) {
		return node;
	}

	// If it's not a function, return it (could be string, number, null, etc.)
	if (typeof node !== 'function') {
		return node;
	}

	// If it's a function, we need to determine if it's a FunctionComponent or a render function
	// Check if it has React component properties (like $$typeof for ForwardRef components)
	if (node && typeof node === 'object' && '$$typeof' in node) {
		// It's a React component object (like ForwardRef), use createElement
		return createElement(node as any, {});
	}

	// Try to use it as a FunctionComponent
	try {
		return createElement(node as FunctionComponent<any>, {});
	} catch (error) {
		// If that fails, try calling it as a regular function
		try {
			return (node as () => ReactNode)();
		} catch (innerError) {
			// If both fail, return null to prevent rendering errors
			console.error('universalRenderer: Failed to render node', error, innerError);
			return null;
		}
	}
};
